import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  href,
  className = '',
  onClick
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 bg-brand-cta hover:bg-brand-cta-hover text-white font-bold transition-all duration-300 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed rounded-xl shadow-lg hover:shadow-brand-cta/20';
  const content = <>{children}</>;
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} data-id="element-45">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={`${baseStyles} ${className}`} data-id="element-46">
      {content}
    </button>;
}